import React, { FunctionComponent, useEffect, useState } from 'react';

import { BrandingUiInfoKeys } from '../../../core/entities';
import { NdvrInteractor } from '../../../core/interactors';
import { ImageUrlGenerator } from '../../../core/utils';
import { ImageLoader } from '../../ImageLoader';

import './MayAlsoLikeItem.scss';

type MayAlsoLikeItemProps = {
    title: string;
    imageUrl: string;
    feedItemId: string;
    altFeedItemId: string;
    feedItemType: string;
};

const MayAlsoLikeItem: FunctionComponent<MayAlsoLikeItemProps> = ({ title, feedItemId }) => {
    const [isImageLoaded, setIsImageLoaded] = useState(true);
    const [imageWidth, setImageWidth] = useState<number | null>(null);
    const imageUrl = new ImageUrlGenerator();
    const services = new NdvrInteractor();
    const DEFAULT_IMAGE = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.DEFAULT_BACKGROUND,
    );
    const ImageUrl = imageUrl.buildImageUrl(
        services.getServicesBaseUrls()['image-host'],
        feedItemId,
        'GALLERY_TILE',
        264,
        198,
    );

    const getImageDimensions = (url: string): Promise<{ width: number; height: number }> => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = (error) => {
                reject(error);
            };
        });
    };

    useEffect(() => {
        if (ImageUrl) {
            getImageDimensions(ImageUrl).then((dimensions) => {
                setImageWidth(dimensions.width);
            });
        }
    }, [ImageUrl]);

    const getCssClassBasedOnWidth = () => {
        if (imageWidth === null) return 'default-class';
        if (imageWidth > 200) return 'wide-image-class';
        if (imageWidth < 200) return 'medium-image-class';
        return 'narrow-image-class';
    };

    return (
        <React.Fragment>
            <div className="content-item-container">
                <div className={`${getCssClassBasedOnWidth()}`}>
                    <ImageLoader
                        src={ImageUrl || DEFAULT_IMAGE?.imageUrl}
                        handleOnImageLoaded={(imageLoadedSuccessfully: boolean) => {
                            setIsImageLoaded(imageLoadedSuccessfully);
                        }}
                    />
                </div>
                <div className="content-item-title-container">
                    <div
                        className="mayAlsoLike-item-title"
                        style={{
                            visibility: !isImageLoaded ? 'visible' : 'hidden',
                        }}
                    >
                        {title}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default MayAlsoLikeItem;
